import { zodResolver } from "@hookform/resolvers/zod";
import {
  type DefaultValues,
  type FieldValues,
  FormProvider as RHFProvider,
  type UseFormReturn,
  useForm,
  useFormContext as useRHFContext,
} from "react-hook-form";
import type { ZodType } from "zod";

export function FormProvider<T extends FieldValues>({
  schema,
  children,
  defaultValues,
}: {
  schema: ZodType<T, any>; // schema matches T
  defaultValues?: DefaultValues<T>;
  children: React.ReactNode;
}) {
  const methods = useForm<T>({
    resolver: zodResolver<T, any, T>(schema),
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues,
  });

  return <RHFProvider {...methods}>{children}</RHFProvider>;
}

export function useFormContext<T extends FieldValues>() {
  return useRHFContext<T>() as UseFormReturn<T>;
}
